import { Undo2 } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnLineItemsEditorRenderer } from "./editor";
import { ReturnLineItemsEmailRenderer } from "./email";
import type { ReturnLineItemsBlockProps } from "./types";

export default registerBlock<ReturnLineItemsBlockProps>({
  type: "return-line-items",
  name: "editorBlocksLibrary.blocks.return-line-items.title",
  description: "editorBlocksLibrary.blocks.return-line-items.description",
  Icon: Undo2,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnLineItemsEmailRenderer,
      editor: {
        component: ReturnLineItemsEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnLineItemsBlockProps } from "./types";
